import React , {useContext} from 'react'
import { FaAngleDoubleUp } from 'react-icons/fa';
import { ThemeContext } from '../App';


const Guide = ({setDisplayRules}) => {
    const theme = useContext(ThemeContext);
    const HINTS = [
        {
            title: 'Peg of the correct color is in the wrong position.',
            color: '#EAF6F6'
        }, 
        {
            title: "Peg of the correct color is in the correct position.",
            color: '#68B984'
        },
        {
            title: 'Peg is not correct.',
            color: '#DC3535'
        }];
    return(
        <div className = {`mx-auto ${theme.backgroundColor} ${theme.foregroundColor} border-2  drop-shadow-lg p-4 rounded-xl`}>
            <p className=''>
                To start, the computer selects a <strong>secret code</strong> of three/four/five(difficulty level) colored pegs. 
                The player tries to guess the code by placing colored pegs in the row of the board. 
                After each guess, the player is given <strong>feedback</strong> in the form of hint pegs(<strong>as below</strong>) placed next to the guess. 
                Using the hints, the player makes a new guess and the game continues.
            </p>
            <div className='sm:mx-4 my-4 md:mx-auto md:w-1/2 text-left'>
                {HINTS.map((hint, i) => {
                    return(
                        <div className='flex inline' key={i}>
                            <Hint key={i} backgroundColor={hint.color} />
                            <span className='ml-4 text-sm font-semibold'>{hint.title}</span>
                        </div>
                    )
                })}
                <div className='my-2 text-sm'>
                    <strong>Note:</strong><span>Hints are not plotted based on sequence of the pegs.</span>
                </div>
            </div>
            <p>
                If the player guesses the secret code before running out of turns, 
                player wins the game. If the player runs out of turns without guessing 
                the secret code, the player lose the game.
                Know more on{" "}
                <a
                href="https://en.wikipedia.org/wiki/Mastermind_(board_game)"
                target="_blank"
                rel="noreferrer"
                className="text-blue-500 underline"
                >
                    Wikipedia
                </a>.
            </p>
            
            <p 
                className ="mt-8 text-sm text-sky-500 font-semibold" 
                onClick={() => setDisplayRules(false)}>
                    <span className="flex justify-center animate-bounce"><FaAngleDoubleUp size={24}/></span>
                    Hide
            </p>
      </div>
    )
}


export default Guide;


const Hint = (props) => {
    return (
      <div
        className="hint drop-shadow-md"
        style={{ backgroundColor: props.backgroundColor }}
      ></div>
    );
};